import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=1833f9f0&scoped=true&"
import script from "./TagEditor.vue?vue&type=script&lang=js&"
export * from "./TagEditor.vue?vue&type=script&lang=js&"
import style0 from "./TagEditor.vue?vue&type=style&index=0&id=1833f9f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833f9f0",
  null
  
)

export default component.exports